module.exports = __webpack_public_path__ + "templates.checkout-object-detail-0e737200.html";